/* Keep Shopify's native installment widget with the main robot purchase buttons. */
if (!customElements.get('ac-installments-position')) {
  customElements.define('ac-installments-position', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.observer = new MutationObserver(() => this.schedule());
      this.reconcile();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    schedule() {
      if (this.frame != null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.reconcile();
      });
    }

    reconcile() {
      this.observer.disconnect();
      try {
        const info = this.section.querySelector('.product-info');
        const buttons = info?.querySelector('.product-info__buy-buttons buy-buttons');
        if (!buttons) return;

        // Older section responses can still include the separate price-area block.
        const oldBlocks = [...info.querySelectorAll(':scope > [data-block-type="payment-terms"]')];
        const oldTerms = oldBlocks.flatMap(block => [...block.querySelectorAll('shopify-payment-terms')]);
        let terms = buttons.querySelector('shopify-payment-terms');
        if (!terms) {
          terms = oldTerms.shift();
          if (!terms) return; // Shopify decides market eligibility; never invent a message.
          let placement = buttons.querySelector('.ac-product-installments');
          if (!placement) {
            placement = document.createElement('div');
            placement.className = 'ac-product-installments';
            buttons.append(placement);
          }
          placement.append(terms);
        }

        buttons.classList.add('ac-installments-buy-buttons');
        for (const duplicate of oldTerms) duplicate.remove();
        for (const block of oldBlocks) {
          // Preserve S10 highlights, which older markup puts in the same block.
          if (!block.textContent.trim() && !block.querySelector('img,video,svg,iframe')) {
            block.hidden = true;
          }
        }
        this.dataset.placementReady = 'true';
      } finally {
        if (this.isConnected) this.observer.observe(this.section, {childList:true, subtree:true});
      }
    }
  });
}
